<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <v-breadcrumbs>
            <v-breadcrumbs-item>
              <router-link to="/">Home</router-link>
            </v-breadcrumbs-item>
            <span class="divider">></span>
            <v-breadcrumbs-item disabled>
              Search Parking Offence Notices
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-col>
      </v-row>

      <v-row no-gutters class="px-5">
        <v-col cols="12" class="mb-8">
            <h1>Search Parking Offence Notices</h1>

            <p>
              Please take note that all over parking compound notices and compound notices payments made at BPS Booths will be automatically updated the following day whereas payments made at BPS Office counters will be updated into BPS servers immediately.<br>
              For convenience, after the search, motorists' can using the print function below to print and make payments at all BPS Booths both the outstanding overdue over parking compound notices and parking compounds notices.
            </p>
        </v-col>

        <v-col cols="12" md="6" class="mb-8">
          <v-row no-gutters class="search-container">
            <v-col cols="9">
              <v-text-field
                v-model="vehicleNo"
                variant="solo"
                label="Please enter your vehicle number ..."
                prepend-inner-icon="mdi-magnify"
                clearable
                hide-details
                class="search-bar"
                :class="{'error--text': !vehicleNo && searched && !rateLimitError}"
                :error="!vehicleNo && searched && !rateLimitError"
                @keydown.enter="searchOffences"
                @input="convertToUppercase"
                :disabled="loading || rateLimitError"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-btn
                color="primary"
                class="search-btn"
                @click="searchOffences"
                :disabled="loading || rateLimitError"
              >
                Search
              </v-btn>
            </v-col>
          </v-row>
          <v-alert
            v-if="!vehicleNo && searched && !rateLimitError"
            type="error"
            border="left"
            colored-border
            elevation="2"
            class="mt-2"
          >
            Please enter your Vehicle Number or Over Parking Notice Number.
          </v-alert>
        </v-col>
      </v-row>

      <v-row no-gutters class="px-5">
        <v-col cols="12" v-if="offences.length > 0">
          <p v-html="offenceCountMessage" class="mb-4"></p>
          <v-card class="px-12 py-8">
            <v-data-table :headers="headers" :items="offences">
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.council }}</td>
                  <td>{{ item.Offence }}</td>
                  <td>{{ item.compound_no }}</td>
                  <td>{{ formatDate(item.compound_date) }}</td>
                  <td>{{ item.area_name }}</td>
                  <td>RM{{ item.amount }}.00</td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" v-if="searched && !offences.length && vehicleNo && !rateLimitError && searchedVehicleNo">
          <p>No overdue notice found on vehicle number <strong>{{ searchedVehicleNo }}</strong></p>
        </v-col>
        <v-col cols="12" v-if="rateLimitError">
          <p>Server is currently busy, please try again later.</p>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import apiClient from '@/axios';

export default {
  name: 'SearchParkingOffence',
  data() {
    return {
      vehicleNo: '',
      offences: [],
      searched: false,
      rateLimitError: false,
      loading: false,
      searchedVehicleNo: '',
      headers: [
        { title: '#', value: 'index' },
        { title: 'City', value: 'council' },
        { title: 'Article', value: 'Offence' },
        { title: 'PA Notice No.', value: 'compound_no' },
        { title: 'PA Date', value: 'compound_date' },
        { title: 'Area Name', value: 'area_name' },
        { title: 'PA Amount', value: 'amount' }
      ]
    };
  },
  computed: {
    offenceCountMessage() {
      return `<strong>${this.uniqueOffences.length}</strong> overdue parking notices found on Vehicle Number <strong>${this.vehicleNo.toUpperCase()}</strong>`;
    },
    uniqueOffences() {
      const seen = new Set();
      return this.offences.filter(offence => {
        const duplicate = seen.has(offence.compound_no);
        seen.add(offence.compound_no);
        return !duplicate;
      });
    }
  },
  methods: {
    async searchOffences() {
      if (!this.vehicleNo) {
        this.searched = true;
        return;
      }
      
      this.offences = []; 
      this.searchedVehicleNo = this.vehicleNo.toUpperCase(); 
      const payload = {
        vehicle_no: this.vehicleNo.toUpperCase() 
      };

      this.loading = true; 
      try {
        const response = await apiClient.post('/api/pa/get-all-unpaid-by-vehicle-no', payload);
        if (response.data && response.data.length > 0) {
          this.offences = response.data;
        } else {
          this.offences = [];
        }
        this.rateLimitError = false;
      } catch (error) {
        if (error.response && error.response.status === 429) {
          this.rateLimitError = true;
        } else {
          console.error('Error fetching offences:', error);
        }
      } finally {
        this.loading = false;
        this.searched = true; 
      }
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('en-US', options);
    },
    convertToUppercase() {
      this.vehicleNo = this.vehicleNo.toUpperCase(); // Convert input to uppercase
    }
  }
};
</script>

